import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link } from 'react-router-dom';
import { SingleResultGrid } from '../../../../../grid/SingleResultGrid';
import { Column } from '../../../../../grid/Column';
import { parseAndShortenFloat } from '../../../../../../helperFunctions/helperFunctions';
import { EditIcon } from '../../../../../icon/EditIcon';

const renderEditEventLink = id => (
  <Link aria-label={`Edit Tsunami Event ${id}`} to={`/view/hazards/tsunami/update-tsunami/${id}`} target="_blank" rel="noopener noreferrer">
    <EditIcon />
  </Link>
);

export const TsunamiSingleResultGrid = ({ tsunami, dataManager }) => (
  <SingleResultGrid data={tsunami}>
    {dataManager && (
      <Column id="edit" cell={({ row }) => renderEditEventLink(row.get('id'))} width={30}>
        <EditIcon />
      </Column>
    )}
    <Column id="year" width={75} helpModalId="year">Year</Column>
    <Column id="month" width={50} helpModalId="month">Mo</Column>
    <Column id="day" width={50} helpModalId="day">Dy</Column>
    <Column id="hour" width={50} helpModalId="hour">Hr</Column>
    <Column id="minute" width={50} helpModalId="minute">Mn</Column>
    <Column id="second" width={75} helpModalId="second">Sec</Column>
    <Column id="eventValidity" width={85} helpModalId="tsuValidity">Tsunami Event Validity</Column>
    <Column id="causeCode" width={85} helpModalId="tsuCauseCode">Tsunami Cause Code</Column>
    <Column id="oceanicTsunami" width={85} helpModalId="tsuOceanicTsunami" cell={({ value }) => (value ? 'Y' : 'N')}>Oceanic Tsunami</Column>
    <Column id="country" width={160} helpModalId="tsuCountry">Country</Column>
    <Column id="locationName" width={200} helpModalId="tsuLocationName">Location</Column>
    <Column id="latitude" width={100} helpModalId="tsuLatitude" cell={({ value }) => (<div>{parseAndShortenFloat(value)}</div>)}>Latitude</Column>
    <Column id="longitude" width={100} helpModalId="tsuLongitude" cell={({ value }) => (<div>{parseAndShortenFloat(value)}</div>)}>Longitude</Column>
    <Column id="maxWaterHeight" width={100} helpModalId="tsuMaxWaterHeight">Maximum Water Height (m)</Column>
    <Column id="tsMtAbe" width={100} helpModalId="tsuMagAbe">Tsunami Magnitude (Abe)</Column>
    <Column id="tsMtIi" width={100} helpModalId="tsuMagIida">Tsunami Magnitude (Iida)</Column>
    <Column id="tsIntensity" width={100} helpModalId="tsuIntensity">Tsunami Intensity</Column>
    <Column id="warningStatusId" width={100} helpModalId="tsuWarnStatus">Warn Status</Column>
  </SingleResultGrid>
);

TsunamiSingleResultGrid.propTypes = {
  tsunami: ImmutablePropTypes.map.isRequired,
  dataManager: PropTypes.bool.isRequired,
};
